export default [{
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_1.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_2.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_3.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_4.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_5.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_6.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_7.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_8.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_9.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_10.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_11.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_12.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_13.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_14.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_15.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_16.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_17.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_18.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_19.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_20.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_21.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_22.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_23.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_24.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_25.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_26.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_27.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_28.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_29.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_30.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_31.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_32.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_33.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_34.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_35.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_36.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_37.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_38.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_39.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_40.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_41.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/5jie/5jie_42.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie5.js